import {
  CONFIRMED_CREATE_SCRIPT_ACTION,
  CONFIRMED_DELETE_SCRIPT_ACTION,
  CONFIRMED_EDIT_SCRIPT_ACTION,
  CONFIRMED_GET_SCRIPT,
} from "../actions/ScriptTypes";

const initialState = {
  scripts: [],
  numRows: 0,
};

// const ScriptReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case CONFIRMED_GET_SCRIPT:
//       return {
//         ...state,
//         scripts: action.payload,
        
//       };

//     case CONFIRMED_CREATE_SCRIPT_ACTION:
//       return {
//         ...state,
//         scripts: [action.payload, ...state.scripts],
//       };

//     case CONFIRMED_EDIT_SCRIPT_ACTION:
//       return {
//         ...state,
//         scripts: state.scripts.map((script) =>
//           script.script_id === action.payload.script_id ? action.payload : script
//         ),
//       };

//     case CONFIRMED_DELETE_SCRIPT_ACTION:
//       return {
//         ...state,
//         scripts: state.scripts.filter(
//           (script) => script.script_id !== action.payload.script_id
//         ),
//       };

//     default:
//       return state;
//   }
// };
const ScriptReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIRMED_GET_SCRIPT:
      return {
        ...state,
        scripts: action.payload.list || [],
        numRows: action.payload.numRows || 0,
      };

    case CONFIRMED_CREATE_SCRIPT_ACTION:
      return {
        ...state,
        scripts: [action.payload, ...state.scripts],
      };

    case CONFIRMED_EDIT_SCRIPT_ACTION:
      return {
        ...state,
        scripts: state.scripts.map((script) =>
          script.script_id === action.payload.script_id
            ? action.payload
            : script
        ),
      };

    case CONFIRMED_DELETE_SCRIPT_ACTION:
      return {
        ...state,
        scripts: state.scripts.filter(
          (script) => script.script_id !== action.payload.script_id
        ),
      };

    default:
      return state;
  }
};
export default ScriptReducer;
